export const ScriptExampleTypeEnum = {
  CASE: 0,
  DATA: 1,
  ATTRIBUTE: 2,
  TIME: 3,
  DOWNLINK: 4,
  MODBUS: 5,
  SO: 6,
  LOG: 7,
};

export function scriptExampleTypeToString(type: number): string {
  switch (type) {
    case ScriptExampleTypeEnum.CASE:
      return "";
    case ScriptExampleTypeEnum.DATA:
      return "Data";
    case ScriptExampleTypeEnum.ATTRIBUTE:
      return "Attribute";
    case ScriptExampleTypeEnum.TIME:
      return "TimeHelper";
    case ScriptExampleTypeEnum.DOWNLINK:
      return "downlinks";
    case ScriptExampleTypeEnum.MODBUS:
      return "Modbus";
    case ScriptExampleTypeEnum.SO:
      return "SO";
    case ScriptExampleTypeEnum.LOG:
      return "Log";
    default:
      return "";
  }
}

export const codeMirrorAutocompleteTypeEnum = {
  METHOD: 0,
  VARIABLE: 1,
  DEVEUI_LOOKUP: 2,
};
